import { render } from "./PersoView.vue?vue&type=template&id=6a399b4b"
import script from "./PersoView.vue?vue&type=script&lang=js"
export * from "./PersoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__